export default "/apps/maps/img/fa-brands-400.svg";